const expertiseOpen = () => {
    const targetNode = document.querySelector('.results-wrapper') || null;
    const alternativeResultsWrapper = document.querySelector('.static-expertise-tabs') || null;
    const observerConfig = {
        childList: true,
    }
    const handleHover = (e) => {
        const target = e.target;
        const currTarget = e.currentTarget;
        if (e.type !== 'keyup') {
            if (currTarget.getAttribute('aria-expanded') === 'true') {
                currTarget.setAttribute('aria-expanded', 'false');
                currTarget.classList.remove('open');
            } else {
                currTarget.setAttribute('aria-expanded', 'true');
                currTarget.classList.add('open');
            }
        } else if (e.type === 'keyup' && target.getAttribute('aria-expanded') === 'true' && e.keyCode === 13) {
            window.location.href = target.querySelector('.btn--module-white.btn--a-z');
        }
    }
    const observeRequestEnd = () => {
        const btn = document.querySelectorAll('.btn--module-white.btn--a-z');
        if (btn.length) {
            [...btn].forEach(btn => {
                btn.parentNode.removeEventListener('mouseover', handleHover);
                btn.parentNode.removeEventListener('focus', handleHover);
                btn.parentNode.removeEventListener('blur', handleHover);
                btn.parentNode.removeEventListener('mouseout', handleHover)
                btn.parentNode.removeEventListener('keyup', handleHover);
            });
            [...btn].forEach(btn => {
                btn.parentNode.addEventListener('blur', handleHover);
                btn.parentNode.addEventListener('mouseover', handleHover);
                btn.parentNode.addEventListener('mouseout', handleHover);
                btn.parentNode.addEventListener('focus', handleHover);
                btn.parentNode.addEventListener('keyup', handleHover);
            });
        }
    }
    if (targetNode) {
        const observer = new MutationObserver(observeRequestEnd)
        observer.observe(targetNode, observerConfig);
    } else if (alternativeResultsWrapper) {
        observeRequestEnd();
    }

};

export default expertiseOpen;
